import React from "react";
import Row from "./row";

class MiddleMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price_data: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }
  handleChange(rowData) {
    // this.setState({ price_data: { ...this.state.price_data, ...rowData } });
    this.state.price_data.push(rowData);
  }
  handleSaveClick() {
    this.props.onSaveClick(this.state.price_data);
  }

  render() {
    var that = this;
    let filterData = JSON.parse(localStorage.getItem("pricing_filters"));
    let category = filterData && filterData.categories && filterData.categories.name ? filterData.categories.name : "";
    const rows = this.props.content.map((obj, index) => (
      <Row
        key={index}
        data={obj}
        selectedRow={this.props.selectedRow}
        tag={that.props.tag}
        actionButton={this.props.onAction}
        handleInputChange={this.handleChange}
      />
    ));

    return (
      <div>
        {/* Middle Upper Start */}
        <React.Fragment>
          <div
            className="top border-box clearfix leftalign"
          >
            <div className="border-box clearfix">
              <div
                className="blackspan65 weight700 floatright"
                style={{ marginRight: "3%" }}
              >
                {/* <button
                style={{ background: "rgb(105, 118, 148)", color: "#ffffff" }}
                id="addleadbtn"
                className="btn btn_small btncard move"
                onClick={this.handleAddClick}
              >
                Add {this.props.label}
              </button> */}
                <button
                  className="btn btn_small btncard move"
                  style={{
                    color: "rgb(255, 255, 255)",
                    backgroundColor: "#5cb85c",
                    borderColor: "#4cae4c",
                  }}
                  onClick={this.handleSaveClick}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          {/* Below button */}
          {/* <Package /> */}
          <div
            className="widthMainComp border-box clearfix leftalign"
            style={{ top: "168px" }}
          >
            <div className="border-box blackspan65 weight700">
              <table className="middleUpperTable stdtable">
                <thead>

                    <tr>
                      <th className="middleUpperTH width6TH">Service</th>
                      <th className="middleUpperTH width3TH">WorkDone</th>
                      <th className="middleUpperTH width2TH">Sales Price</th>
                      <th className="middleUpperTH width2TH">Maximum Rate</th>
                    </tr>
                 
                </thead>
              </table>
            </div>
          </div>
        </React.Fragment>
        {/* Middle Upper End */}

        {/* Middle Main Start */}
        <div
          className="main border-box leftalign"
          style={{ height: "22.35rem", overflowY: "scroll", marginTop: "51px" }}
        >
          {!this.props.showContent ? (
            <React.Fragment />
          ) : this.props.content.length == 0 ? (
            <div className="empty centeralign weight400 blackspan56">
              No Data Found
            </div>
          ) : (
                rows
              )}
        </div>
        {/* Middle Main End */}
      </div>
    );
  }
}

export default MiddleMain;
